import { AxiosGETRequest, RequestMethod } from '@myme/utils';

export const getFeedMymesAPI: AxiosGETRequest = {
  method: RequestMethod.GET,
  cacheKeys: ['getFeedMymesAPI'],
  path: '/feed'
};

export const getFeedSearchAPI: AxiosGETRequest = {
  method: RequestMethod.GET,
  cacheKeys: ['getFeedSearchAPI'],
  path: '/feed/search'
};

export const getPopularMymesAPI: AxiosGETRequest = {
  method: RequestMethod.GET,
  cacheKeys: ['getPopularMymesAPI'],
  path: '/feed/popular'
};
